import eMoneyLogo from '../images/payments/e-money.jpeg';
import instaPayLogo from '../images/payments/instapay.jpeg';
import orangeCashLogo from '../images/payments/orange-cash.jpeg';
import vodafoneCashLogo from '../images/payments/vodafone-cash.jpeg';

export const SOCIAL_PLAN = 'SOCIAL';
export const ALL_IN_ONE_PLAN = 'ALL_IN_ONE';
export const PAYMENT_PLAN = 'PAYMENT';

export const PLAN_OPTIONS = [
  {
    value: SOCIAL_PLAN,
    label: 'Social Media',
    description: 'Social accounts with your bio, email, address, website, and location.'
  },
  {
    value: ALL_IN_ONE_PLAN,
    label: 'All in One',
    description: 'Social accounts, contact details, documents, and custom links.'
  },
  {
    value: PAYMENT_PLAN,
    label: 'Payments',
    description: 'A payment-only profile for supported payment providers.'
  }
];

export const PAYMENT_PROVIDERS = [
  {
    value: 'INSTAPAY', label: 'InstaPay', shortLabel: 'IP', logo: instaPayLogo
  },
  {
    value: 'VODAFONE_CASH', label: 'Vodafone Cash', shortLabel: 'VC', logo: vodafoneCashLogo
  },
  {
    value: 'E_MONEY', label: 'e& money', shortLabel: 'e&', logo: eMoneyLogo
  },
  {
    value: 'ORANGE_CASH', label: 'Orange Cash', shortLabel: 'OC', logo: orangeCashLogo
  }
];

export const getUserPlan = (plan) => (
  PLAN_OPTIONS.some((option) => option.value === plan) ? plan : SOCIAL_PLAN
);

export const getPlanLabel = (plan) => {
  const normalizedPlan = getUserPlan(plan);
  const option = PLAN_OPTIONS.find((item) => item.value === normalizedPlan);

  return option.label;
};

export const getPaymentProvider = (provider) => (
  PAYMENT_PROVIDERS.find((item) => item.value === provider) || PAYMENT_PROVIDERS[0]
);

export const createDefaultPaymentLinks = () => PAYMENT_PROVIDERS.map((provider) => ({
  provider: provider.value,
  url: '',
  label: ''
}));
